import React from "react";

const User02 = ({ width, height, color }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    width={width || "24"}
    height={height || "24"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color || "#000000"}
      d="M16 4.02904C17.4817 4.76539 18.5 6.29442 18.5 8.06128C18.5 9.82814 17.4817 11.3572 16 12.0935M18 17.3277C19.5115 18.0116 20.8725 19.1263 22 20.5613M2 20.5613C3.94649 18.0839 6.58918 16.5613 9.5 16.5613C12.4108 16.5613 15.0535 18.0839 17 20.5613M14 8.06128C14 10.5466 11.9853 12.5613 9.5 12.5613C7.01472 12.5613 5 10.5466 5 8.06128C5 5.576 7.01472 3.56128 9.5 3.56128C11.9853 3.56128 14 5.576 14 8.06128Z"
    />
  </svg>
);

export default User02;
